import { debounce } from 'lodash';
import { useMemo } from 'react';
import { useUpdateEffect } from 'react-use';
import { useEventCallback } from '@mssgme/hooks';

export const useAutoSubmit = (formik, delay = 400) => {
    const shouldAutoSubmit = formik.dirty;

    const submit = useEventCallback(() => formik.submitForm());
    const debouncedSubmit = useMemo(() => debounce(submit, delay), [delay]);

    useUpdateEffect(() => {
        if (shouldAutoSubmit) {
            void debouncedSubmit();
        }
    }, [debouncedSubmit, shouldAutoSubmit]);
};
